import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/command-line/prism-command-line.css';

import './src/assets/style/prism-init.css';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated.
Reload to display the latest version?`
  );
  if (answer === true) {
    window.location.reload();
  }
  return;
};
